import React from 'react';
import { MotorhomeExcessReductionTabPanel } from '@/components/blocks/MotorhomeDetails/TabPanels/MotorhomeExcessReductionTabPanel';
import { MotorhomeFeaturesTabPanel } from '@/components/blocks/MotorhomeDetails/TabPanels/MotorhomeFeaturesTabPanel';
import { MotorhomeSpecificationsTabPanel } from '@/components/blocks/MotorhomeDetails/TabPanels/MotorhomeSpecificationsTabPanel';
import { IMotorhomeTabs, IMotorhomeTabsTitles } from './MotorhomeDetails';

export const MotorhomeTabPanel = ({ tab }: { tab: IMotorhomeTabs }) => {
    if (tab.title === IMotorhomeTabsTitles.ExcessReduction) {
        return <MotorhomeExcessReductionTabPanel tab={tab} />;
    }

    if (tab.title === IMotorhomeTabsTitles.Features) {
        return <MotorhomeFeaturesTabPanel tab={tab} />;
    }

    return <MotorhomeSpecificationsTabPanel tab={tab} />;
};
